import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph'; // Assuming you still want to use morph for consistency

class ProductVariantText extends HTMLElement {
  connectedCallback() {
    // Find the closest section or dialog element to listen for variant updates
    const closestSection = this.closest('.shopify-section, dialog');
    if (closestSection) {
      closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateTextField);
    }
  }

  disconnectedCallback() {
    // Clean up the event listener when the element is removed from the DOM
    const closestSection = this.closest('.shopify-section, dialog');
    if (closestSection) {
      closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateTextField);
    }
  }

  /**
   * Updates the text field based on the variant update event.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateTextField = (event) => {
    // This part is crucial for ensuring the event applies to *this* product element
    // If the event provides a newProduct, update the product ID this element is associated with
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    }
    // If the event source's product ID doesn't match this element's product ID,
    // it means the event is for a different product form on the page (e.g., quick view),
    // so we should ignore it.
    else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    // Get the new HTML fragment from the event detail
    const newHtml = event.detail.data.html;

    // Query the new HTML fragment for an element with the same custom tag
    // This is where you would place the content you want to update dynamically.
    // Make sure the Liquid code also renders this new <product-variant-text> element.
    const newTextFieldContent = newHtml.querySelector('product-variant-text');

    // If no new content is found, exit
    if (!newTextFieldContent) {
      // You might want to clear the content here if the new variant doesn't have the field
      this.textContent = ''; // Or display a default message
      return;
    }

    // Use morph to update the content of this custom element
    // 'childrenOnly: true' is good if you only want to update the inner HTML
    morph(this, newTextFieldContent, { childrenOnly: true });

    // Alternatively, if morph is overkill and you just want to update text:
    // this.textContent = newTextFieldContent.textContent;
  };
}

// Define the custom element if it hasn't been defined already
if (!customElements.get('product-variant-text')) {
  customElements.define('product-variant-text', ProductVariantText);
}